// Plugins
import 'jquery.payment';
import 'accounting';
import 'uiblocker';
import 'magnific-popup';

// Give plugins.
import '../plugins/give-hint.css';

// Give core.
import './give-ajax';
import './give-donations';
import './give-misc';


// WEBPACK FOOTER //
// ./assets/src/js/frontend/give.js